import { required, numeric, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    output: {
      actual_quantity: {
        required: helpers.withMessage(i18n.global.t('Please enter a quantity.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity.'), numeric)
      }
    }
  }
};
